
import Subject from "@mui/icons-material/Subject";
import Gavel from "@mui/icons-material/Gavel";
import ViewList from "@mui/icons-material/ViewList";
import Configuration from "@brightlayer-ui/icons-mui/Configuration";
import ProtectionCurve from "@brightlayer-ui/icons-mui/ProtectionCurve";

export const LINEPRO_NAVIGATION_MENU = [
  {
    id: 38,
    name: "Manage",
    titleKey: "menu.linepro.manage",
    icon: <Subject />,
    link: "/linepro/manage",
    version: "0.0.49"
  },
  {
    id: 65,
    name: "Protection Settings",
    titleKey: "menu.linepro.settings",
    icon: <ProtectionCurve />,
    link: "/linepro/settings",
    version: "0.0.49"
  },
  {
    id: 265,
    name: "Configure",
    titleKey: "menu.linepro.configure",
    icon: <Configuration />,
    link: "/linepro/configure",
    version: "0.0.49"
  },
  {
    id: 347,
    name: "Event Logs",
    titleKey: "menu.linepro.logs",
    icon: <ViewList />,
    link: "/linepro/logs",
    version: "0.0.49"
  },
  {
    id: 384,
    name: "Display",
    titleKey: "menu.linepro.display",
    icon: "",
    link: "/linepro/display",
    version: "0.0.49"
  },
  {
    id: 402,
    name: "Export & Language",
    titleKey: "menu.linepro.exportandlanguage",
    icon: <Configuration />,
    link: "/linepro/exportandlanguage",
    version: "0.0.49"
  },
  {
    id: 404,
    name: "License Information",
    titleKey: "menu.linepro.licenseInformation",
    icon: <Gavel />,
    link: "/linepro/licenseInformation",
    version: "0.0.49"
  }
];
